function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M120.586 61L90.887 90.699c-16.402 16.402-42.995 16.402-59.398 0-16.402-16.402-16.402-42.996 0-59.398 16.403-16.402 42.996-16.402 59.398 0L120.586 61z",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.58 35l14.287 14.29c7.892 7.89 7.892 20.686 0 28.578v0c-7.891 7.891-20.686 7.891-28.578 0v0c-7.892-7.892-7.892-20.687 0-28.579L61.579 35z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61 53v51M51.491 62.156l9.957 9.957M71.404 62.156l-9.956 9.957",
  stroke: "currentColor",
  strokeWidth: 2
});

var SvgEmblemEnvironment = function SvgEmblemEnvironment(props) {
  return React.createElement("svg", _extends({
    width: 122,
    height: 122,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgEmblemEnvironment;